import { lazy } from "react";
import "./App.css";

import { BrowserRouter as Router } from "react-router-dom";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { baseThemeOptions } from "./theme/base-theme";
import { darkThemeOptions } from "./theme/dark-theme";
import Routes from "./Routes";
import { AuthProvider } from "./context/AuthContext";
import { WalletWrapper } from "./components/WalletWrapper/WalletWrapper";
import "react-notifications/lib/notifications.css";
import BulkTransactionsModal from "./components/BulkTransactionModal/BulkTransactionModal";
import { NotificationContainer } from "react-notifications";

const Layout = lazy(() => import("./layout/Layout/Layout"));

const App = () => {
  const theme = createTheme(baseThemeOptions, darkThemeOptions);

  return (
    <WalletWrapper>
      <ThemeProvider theme={theme}>
        <Router>
          <AuthProvider>
            <Layout>
              <Routes />
            </Layout>
            <NotificationContainer />
          </AuthProvider>
          <BulkTransactionsModal />
        </Router>
      </ThemeProvider>
    </WalletWrapper>
  );
};

export default App;
